// extracted by mini-css-extract-plugin
module.exports = {"container":"SketchNavigationButton_container__2_Dh6","button":"SketchNavigationButton_button__1pe5I","icon":"SketchNavigationButton_icon__1uqn8"};